export const getProgressBarAmount = (amountRaised = 0, goal = 0) => {
  if (!goal) {
    return 0;
  }
  return Math.min((amountRaised / goal) * 100, 100);
};

export const fundingPercentage = (amountRaised = 0, goal = 0): number =>
  Math.floor((amountRaised / goal) * 100) || 0;
